import { useCallback, useState } from "react";

/**
 * useState respaldado por localStorage. Un único lugar para leer/escribir
 * preferencias del sidebar (favoritos, recientes, tema, modo compacto),
 * en vez de repetir el mismo try/catch de JSON.parse en cada hook.
 */
export function useLocalStorageState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw !== null ? JSON.parse(raw) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const update = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        try {
          window.localStorage.setItem(key, JSON.stringify(resolved));
        } catch {
          // Almacenamiento no disponible (modo privado, cuota excedida, etc.):
          // el estado en memoria sigue funcionando para la sesión actual.
        }
        return resolved;
      });
    },
    [key]
  );

  return [value, update];
}
